import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  changePasswordWrapper: {},
  changePasswordForm: {
    marginTop: '8px',
  },

  backToLogin: {
    textAlign: 'center',
    width: '100%',
    marginTop: '32px',
    fontWeight: 400,
    fontSize: '12px',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
  },
  textField: {
    '&:not(:first-of-type)': {
      marginTop: '16px',
    },
  },
}));
